module.exports = __webpack_public_path__ + "static/media/creditOption-sub.59ab6084.svg";